export const NOTIFICATION_TYPES = Object.freeze({
  ADD_FINDING_ASSIGNEE: 'addFindingAssignee',
  ADD_NEW_COLLABORATOR: 'addNewCollaborator',
  ADD_NEW_COACH: 'addNewCoach',
  ADD_ROOT_CAUSE_ASSIGNEE: 'addRootCauseAssignee',
  ADD_ROUTINE_ASSIGNEE: 'addRoutineAssignee',
  AI_TOKENS_LIMIT_100_THRESHOLD_REACHED: 'aiTokensLimit100ThresholdReached',
  AI_TOKENS_LIMIT_70_THRESHOLD_REACHED: 'aiTokensLimit70ThresholdReached',
  AI_TOKENS_LIMIT_80_THRESHOLD_REACHED: 'aiTokensLimit80ThresholdReached',
  AI_TOKENS_LIMIT_90_THRESHOLD_REACHED: 'aiTokensLimit90ThresholdReached',
  BOARD_SHARED: 'boardShared',
  CHALLENGE_COMMENT_CREATED: 'challengeCommentCreated',
  CHALLENGE_CREATED: 'challengeCreated',
  CHALLENGE_LINKED: 'challengeLinked',
  COMMENT_CREATED: 'commentCreated',
  INACTIVE_USERS_IN_REV_REMINDER: 'inactiveUsersInRevReminder',
  MEMBER_ADDED_TO_TEAM: 'memberAddedToTeam',
  RECOGNITION_LIKED: 'recognitionLiked',
  RECOGNITION_RECEIVED: 'recognitionReceived',
  REPORT_GENERATED: 'reportGenerated',
  REV_COMPLETED: 'revCompleted',
  REV_COMPLETED_WITH_COACH: 'revCompletedWithCoach',
  REV_COMPLETED_WITHOUT_COACH: 'revCompletedWithoutCoach',
  REV_DELETED: 'revDeleted',
  REV_FINANCIALLY_VALIDATED: 'revFinancialValidated',
  REV_IMPLEMENTED: 'revImplemented',
  REV_LIKED: 'revLiked',
  REV_MARKED_NOT_VALID: 'revMarkedNotValid',
  REV_REPLICATED: 'revReplicated',
  REV_STATUS_CHANGE: 'revStatusChange',
  REVS_ASSIGNED_PENDING_TO_VALIDATE_REMINDER:
    'revsAssignedPendingToValidateReminder',
  REVS_PENDING_TO_COMPLETE_REMINDER: 'revsPendingToCompleteReminder',
  REVS_PENDING_TO_IMPLEMENT_REMINDER: 'revsPendingToImplementReminder',
  REVS_PENDING_TO_REQUEST_VALIDATION_REMINDER:
    'revsPendingToRequestValidationReminder',
  REVS_PENDING_TO_VALIDATE_REMINDER: 'revsPendingToValidateReminder',
  ROUTINE_APPROVAL_DAILY_REMINDER: 'routineApprovalDailyReminder',
  ROUTINE_APPROVAL_REJECTED: 'routineApprovalRejected',
  ROUTINE_APPROVAL_REQUESTED: 'routineApprovalRequested',
  ROUTINE_APPROVED: 'routineApproved',
  ROUTINE_COLLABORATOR_ADDED: 'routineCollaboratorAdded',
  ROUTINE_COLLABORATOR_REMOVED: 'routineCollaboratorRemoved',
  ROUTINE_DEFINITION_REMINDER: 'routineDefinitionReminder',
  SECONDARY_INVITATION: 'secondaryInvitation',
  SHARE_REV: 'shareRev',
  TASK_ASSIGNED: 'taskAssigned',
  TASK_ATTACHMENT_ADDED: 'taskAttachmentAdded',
  TASK_COMPLETED: 'taskCompleted',
  TASK_DUE_DATE_CHANGED: 'taskDueDateChanged',
  TASK_STATUS_CHANGED: 'taskStatusChanged',
  TASKS_REMINDER: 'tasksReminder',
  USER_AI_TOKENS_EXHAUSTED: 'userAITokensExhausted',
  VALIDATION_REQUEST_ASSIGNED: 'validationRequestAssigned',
  VALIDATION_REQUEST_REJECTED: 'validationRequestRejected',
})

export const NOTIFICATION_ENTITIES = Object.freeze({
  BOARD: 'board',
  CHALLENGE: 'challenge',
  COMMENT: 'comment',
  FINDING: 'finding',
  IMPROVEMENT_IDEA: 'improvementIdea',
  PROBLEM_SOLVING: 'problemSolving',
  RECOGNITION: 'recognition',
  REPORT: 'report',
  REV: 'rev',
  ROUTINE_DEFINITION: 'routineDefinition',
  ROUTINE_EXECUTION: 'routineExecution',
  TASK: 'task',
})
